import { render, staticRenderFns } from "./height-transition.vue?vue&type=template&id=06046c86&scoped=true&"
import script from "./height-transition.vue?vue&type=script&lang=js&"
export * from "./height-transition.vue?vue&type=script&lang=js&"
import style0 from "./height-transition.vue?vue&type=style&index=0&id=06046c86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06046c86",
  null
  
)

export default component.exports